import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AlertBox from './AlertBox'
import frm from './formAux.js'
import $ from 'jquery';
import InputGroup from 'react-bootstrap/InputGroup';

var demoDone = false;
function Register(prop) {

    const urlSearchParams = new URLSearchParams(window.location.search);
    const tierValue = urlSearchParams.get('tier');
    const planValue = urlSearchParams.get('plan');
    console.log('tierplan', tierValue, planValue)

    // JavaScript code to generate a captcha
    function genCaptcha(){
        const fonts = [
            "Arial",
            "Helvetica",
            "Times New Roman",
            "Courier New",
            "Verdana",
            "Georgia",
            "Palatino",
            "Garamond",
            "Bookman",
            "Comic Sans MS",
          ];
    
          // Generate a random CAPTCHA text
          const captchaText = Math.random().toString(36).substr(2, 5);
    
          // Get a random font from the list
          const randomFont = fonts[Math.floor(Math.random() * fonts.length)];

          const captcha = document.getElementById('captcha_preview');
          captcha.style.fontFamily = randomFont;
          captcha.innerHTML = captchaText;
    }
    function generateCaptcha() {
        const captchaLength = 6; // Number of characters in the captcha
        const captchaChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // Valid characters for the captcha
        let captcha = '';
    
        // Generate a random captcha by selecting characters from the valid set
        for (let i = 0; i < captchaLength; i++) {
        captcha += captchaChars.charAt(Math.floor(Math.random() * captchaChars.length));
        }
    
        // Display the captcha in the HTML form
        document.getElementById('captcha_preview').innerHTML = captcha;
    }


    //mani
    var mode = 0;
    useEffect(function (a) {
        window.FreshworksWidget('hide'); //hide Freshworkwidgets mani

        // Call the generateCaptcha() function when the page is loaded
        generateCaptcha();

        $('.top_switch').remove();
        localStorage.clear();
        var pp = window.getPageParams();
        // delete window.GlobalVars.postLogin;
        // alert( pp.next )
        if (pp.next) {
            try {
                var pl = atob(pp.next);
                window.GlobalVars.postLogin = pl; 
            }
            catch (e) { console.error(e) }
            return window.saveSession( () => {
                document.location = '/?next=#Login';
            });
        }
        // if( document.location.href.indexOf('?next=#Login') == -1 ) {
        //     return document.location = '/?next=#Login';
        // }
        $('#button').off('click').on('click', submit )
        
    })
    async function submit(e)
    {
        e.preventDefault();
        if( demoDone ) return;
        window.endSession();
        window.alertOut();
        var email = $('#email').val().trim();
        var firstname = $('#firstname').val().trim();
        var lastname = $('#lastname').val().trim();
        var company = $('#company').val().trim();
        var phone = $('#phone').val().trim();
        var tier = $('#tier').val().trim();
        var plan = $('#plan').val().trim();
        let captcha = document.getElementById('captcha_preview').innerHTML;
        let input = document.getElementById('captcha').value;

        if(tier == '' && plan == ''){
            tier = 'free'; plan = ''
        }
        if(!(captcha === input)){
            return window.alertBox( 'Please Enter correct captcha', 'err' );
        }
        if( firstname == '' )
        {
            $('#firstname').focus();
            return window.alertBox( 'Please Enter your First Name', 'err' );
        }
        if( lastname == '' )
        {
            $('#lastname').focus();
            return window.alertBox( 'Please Enter your Last Name', 'err' );
        }
        if( company == '' )
        {
            $('#company').focus();
            return window.alertBox( 'Please Enter your Company Name', 'err' );
        }
        if( email == '' )
        {
            $('#email').focus();
            return window.alertBox( 'Please Enter your Email Address', 'err' );
        }
        function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email = $("#email").val();
            if (email.includes("@gmail.com") || email.includes("@yahoo.com") || email.includes("@outlook.com")) {
                // return window.alertBox('Please enter a valid business email address')
                return;
            }
            return re.test(String(email).toLowerCase());
        }
        if( !validateEmail(email) ) return window.alertBox( 'Please use a valid  business Email address', 'err' );
        let res = await window.post( 'register_new_user', {
            fname:firstname,
            lname:lastname,
            company:company,
            userInfo:{company:company},
            email:email,
            phone:phone,
            tier:tier,
            plan:plan
        })
        var data = res.data;
        console.log('DEMO', data)
        if (data.status) {
            window.alertOut();
            window.endSession();
            window.GlobalVars.user = email;
            window.GlobalVars.userName = firstname + ' ' + lastname + ' (guest)';
            var priv = { user: 1 };
            window.GlobalVars.userPriv = priv;
            window.GlobalVars.sessionId = Math.random();
            window.GlobalVars.expireTime = Date.now() + 1000 * 60 * window.sessionDuration;
            window.saveSession();

            window.alertBox('An email was sent to <b>' + email + '</b> with your verification code. Please type your verification code below.', 'ok');
            $('.formcontent').html('<input placeholder="type verification code" type="text" id="vcode" class=" mb-2 form-control"><button id="verify" type="submit" class="mt-2 btn btn-primary">Verify</button>');
            setTimeout( function(){
                $('#vcode')[0].focus();
            }, 500 )
            $('#verify').off('click').on('click', verifyCode );
            async function verifyCode(ev){
                ev.preventDefault()
                ev.stopPropagation();
                let password = $('#vcode').val();
                window.alertOut();
                let res = await window.post( 'login', {email:email,password:password});
                console.log( 'res', res )
                let data = res.data;
                if( data.status ) {
                    window.endSession();
                    var global = window.GlobalVars;
                    global.user = email;
                    global.userName = data.name;
                    global.userSession = data.sid;
                    global.userId = data._id;
                    global.userEmail = data.email;
                    global.userWorkerId = data.workerId;
                    global.userRoles = data.roles;
                    global.userPriv = {nlp_an: true};
                    global.sessionId = Math.random();
                    global.expireTime = Date.now()+1000*60*window.sessionDuration;
                    if( data.redefinePassword ) {
                        global.userRedefinePassword = data.redefinePassword;
                    }
                    window.saveSession();
                    window.alertBox( ' Signing in', 'loading')

                    /// BEFORE GOING TO accountSettings YOU MUST await post the new method to create the company and role
                    await window.post('create_registered_company_user_role', {})

                    setTimeout( function(){
                        window.goPage('accountSettings')
                    }, 1000 );
                }
                else {
                    return window.alertBox( 'Invalid code', 'err' );
                }
            }
        }
        else {
            window.alertBox(data.value, 'err');
        }
    }

    return (
        <div className="login_wrapper">
        <Container fluid="md" className="mp0">
        <Row>
        <Col sm={3}></Col>
        <Col sm={6}>
        {/* <img className="login-logo" src="imgs/objectways-logo.png"/>15/4 mani */}
        <img className="login-logo" src="imgs/new/f3.svg" /> 
        <div className="login">
        <Form method="GET">
            {/* <Form.Label><h3>Datalake Register Version</h3> */}
            <Form.Label><h3>Sign Up</h3>
            {/* <span id="subtxt">Enter the details below to access the Register</span> */}
            </Form.Label>
            <AlertBox/>
            <div className="formcontent">
                <Row>
                    <Col className="mr-0 pr-0">
                    <Form.Control placeholder="First name *" id="firstname" className="err"/>
                    </Col>
                    <Col className="ml-0 pl-2">
                    <Form.Control placeholder="Last name *"  id="lastname"/>
                    </Col>
                </Row>
                <FormControl  type="text" id="company" placeholder="Company Name * " className=" mb-2"/>
                <FormControl  type="e-mail" className="mb-2" id="email" placeholder="yourmail@company.com * "/>
                <FormControl type="number" className="mb-2" id="phone" placeholder="Phone Number "/>
                <div className="mb-2 captcha_main" style={{display: 'flex'}}>
                <div className="captcha_field" style={{height: '40px', flex: '1', display: 'flex', position: 'relative'}}>
                    <img src="/imgs/captcha-bg-img.jpg" alt="captcha-bg-img" style={{height: '100%', width: '100%', objectFit: 'cover', opacity: '0.6'}} />
                    <div id="captcha_preview" style={{fontWeight: 'bolder', userSelect: 'none', padding: '7px', marginRight: '2px', color: '#555', letterSpacing: '20px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}/>
                </div>
                <div onClick={generateCaptcha} style={{border: '1px solid lightgray', padding: '7px', cursor: 'pointer', display: 'flex', alignItems: 'center'}}><span style={{color: '#555'}}><i class="fa fa-refresh" aria-hidden="true"></i></span></div>
                </div>
                {/* <input type="text" id="captcha" placeholder="Enter the captcha"/> */}
                <FormControl type="text" className="mb-2" id="captcha" placeholder="Enter the captcha "/>
                <FormControl type="hidden" className="mb-2" id="tier" value={tierValue}/>
                <FormControl type="hidden" className="mb-2" id="plan" value={planValue}/>
                <Button variant="primary" id="button" type="submit" className="mt-2">Sign Up</Button>
            </div>
        </Form>
        </div>
        </Col>
        <Col sm={3}></Col>
        </Row>
        </Container>
        </div>
    )

}

export default Register
